/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EFiscalItemDto } from './EFiscalItemDto';
import {
    EFiscalItemDtoFromJSON,
    EFiscalItemDtoFromJSONTyped,
    EFiscalItemDtoToJSON,
} from './EFiscalItemDto';

/**
 * 
 * @export
 * @interface EFiscalDocumentDto
 */
export interface EFiscalDocumentDto {
    /**
     * Printer UID
     * @type {string}
     * @memberof EFiscalDocumentDto
     */
    uid: string;
    /**
     * Array of e-fiscal items
     * @type {Array<EFiscalItemDto>}
     * @memberof EFiscalDocumentDto
     */
    eparagon: Array<EFiscalItemDto>;
}

/**
 * Check if a given object implements the EFiscalDocumentDto interface.
 */
export function instanceOfEFiscalDocumentDto(value: object): value is EFiscalDocumentDto {
    if (!('uid' in value) || value['uid'] === undefined) return false;
    if (!('eparagon' in value) || value['eparagon'] === undefined) return false;
    return true;
}

export function EFiscalDocumentDtoFromJSON(json: any): EFiscalDocumentDto {
    return EFiscalDocumentDtoFromJSONTyped(json, false);
}

export function EFiscalDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EFiscalDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'uid': json['uid'],
        'eparagon': ((json['eparagon'] as Array<any>).map(EFiscalItemDtoFromJSON)),
    };
}

export function EFiscalDocumentDtoToJSON(value?: EFiscalDocumentDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'uid': value['uid'],
        'eparagon': ((value['eparagon'] as Array<any>).map(EFiscalItemDtoToJSON)),
    };
}

